export const FEATURES = {
  ENABLE_ZORGMAIL: true,
  CALCULATED_DIARY: true,
};
